import firebase from 'firebase/app';

const auth = firebase.auth();

if (process.env.REACT_APP_ENVIRONMENT_NAME === 'EMULATOR') {
  auth.useEmulator('http://localhost:9099');
}

export default auth;
